import { BENEFIT_TYPE_VISION } from '@hixme/benefit-types'
import { clearModal } from '@hixme/modal'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { connectWaiter, getWaiter } from 'redux-waiter'
import { getClientBenefits } from 'modules/api/client-benefits-get'

// project
import DeclineCoverageModal from 'components/DeclineCoverageModal'

// store
import cart from 'store/modules/cart'
import userSession from 'store/modules/user-session'

// module
import { handleActivityLogPopup } from 'helpers/activityLogHelper'
import { datadog } from 'helpers/datadog'
import withFeatureFlags from 'hocs/withFeatureFlags'
import { logGenericActivity } from 'modules/activity-log/log-generic-activity'
import { createErrorNotification } from 'modules/notification-manager/actions'
import { ShopForHealthAction } from 'routes/Benefits/HealthBundles/shop-for-health-activity-log/shop-for-health-log'
import person from 'store/modules/persons'
import { isImpersonating } from 'store/modules/user-session/selectors'
import { constants } from '../modules/vision-coverage'

const mapStateToProps = (state, props) => {
  const waiter = getWaiter(state, constants.GET_VISION_PLANS)
  const flags = props?.flags
  const personData = person.selectors.getPersonSelector(state)

  const isActivityLogEnabled = flags['enrollme.activity-log-reason-popup-enabled']
  const isImpersonated = isImpersonating(state)
  const isTestUser = personData?.IsTestUser
  return {
    benefitProducts: (waiter.response && waiter.response.ClientBenefits) || [],
    enrollmentKey:
      props.data?.enrollmentPublicKey || userSession.selectors.getEnrollmentPublicKey(state),
    coveredPersons: props.data?.persons
      ? props.data.persons.map((person) => ({ Id: person.personPublicKey }))
      : [
          person.selectors.getPersonSelector(state),
          ...person.selectors.getDependentsEligibleForBenefits(state),
        ],
    isProcessing: getWaiter(state, cart.constants.CART_VISION_POST).isPending || false,
    isActivityLogEnabled,
    isImpersonated,
    isTestUser,
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  onDeclineClick: (coveredPersons, benefitProducts, enrollmentKey, onDeclineProps) => {
    const callback = ({ reason, reasonCategory, zendeskTicket }) => {
      dispatch(cart.actions.declineVisionProduct(coveredPersons, benefitProducts, enrollmentKey))
        .then(
          () => {
            datadog.declineBenefits(BENEFIT_TYPE_VISION, coveredPersons, benefitProducts)
            logGenericActivity({
              additionalData: {
                coveredPersons,
                benefit: [benefitProducts],
                enrollmentKey,
                reason,
                reasonCategory,
                zendeskTicket,
              },
              activity: 'declined vision coverage',
              action: ShopForHealthAction.DeclineVisionCoverage,
            })
            if (props.data?.enrollmentPublicKey) {
              props.data?.onDecline?.()
            } else {
              dispatch(userSession.actions.pushNextBenefitRoute())
            }
          },
          () => {
            dispatch(
              createErrorNotification('There was an error declining vision. Please try again.')
            )
          }
        )
        .finally(() => dispatch(clearModal()))
    }

    handleActivityLogPopup({
      isImpersonated: onDeclineProps.isImpersonated,
      isTestUser: onDeclineProps.isTestUser,
      isActivityLogEnabled: onDeclineProps.isActivityLogEnabled,
      dispatch,
      contentText: 'Are you sure you want to decline this vision coverage?',
      onSubmit: callback,
    })
  },
})

export default compose(
  withFeatureFlags,
  connect(mapStateToProps, mapDispatchToProps),
  connectWaiter({
    name: constants.GET_VISION_PLANS,
    requestCreator: ({ EnrollmentPublicKey, PersonPublicKeys }) =>
      getClientBenefits({
          EnrollmentPublicKey,
          BenefitType: BENEFIT_TYPE_VISION,
          PersonPublicKeys,
        }),
    requestOnMountParams: ({ enrollmentKey, coveredPersons }) => {
      const keys = coveredPersons.map((i) => i.Id)
      return {
        EnrollmentPublicKey: enrollmentKey,
        PersonPublicKeys: keys,
      }
    },
  })
)(DeclineCoverageModal)
